/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { SafePureComponent } from '../../../../utils/SafePureComponent';
import * as styles from './index.styles';

class Checkbox extends SafePureComponent {
  safeRender() {
    const {
      id,
      label,
      error,
      disabled,
      labelCss,
      className,
      errorMessage,
      inputProps,
      value,
    } = this.props;
    return (
      <div css={styles.checkbox} className={className}>
        <input
          onChange={this.props.onChangeProp}
          name={id}
          checked={value}
          type="checkbox"
          id={`checkbox-${id}`}
          disabled={disabled}
          {...inputProps}
        />

        <label css={labelCss} htmlFor={`checkbox-${id}`} data-error={error}>
          {label}
        </label>

        <p
          id={`${id}-helper-text`}
          css={error && styles.checkboxError}
          data-disabled={disabled}
        >
          {error && errorMessage}
        </p>
      </div>
    );
  }
}

Checkbox.displayName = 'Checkbox';

Checkbox.defaultProps = {
  id: '',
  label: '',
  onChangeProp: () => {},
  disabled: false,
  error: false,
  value: false,
  labelCss: {},
  className: '',
  errorMessage: '',
  inputProps: {},
};

Checkbox.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  error: PropTypes.bool.isRequired,
  value: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  onChangeProp: PropTypes.func,
  labelCss: PropTypes.object,
  className: PropTypes.string,
  errorMessage: PropTypes.string,
  inputProps: PropTypes.any,
};

export default Checkbox;
